import { render, staticRenderFns } from "./InvoiceDataModal.vue?vue&type=template&id=24609ade"
import script from "./InvoiceDataModal.vue?vue&type=script&lang=js"
export * from "./InvoiceDataModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDataModal.vue?vue&type=style&index=0&id=24609ade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports